import { Component } from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-win-ols-solutions-wrapper',
  standalone: true,
    imports: [
        RouterOutlet
    ],
  templateUrl: './win-ols-solutions-wrapper.component.html',
  styleUrl: './win-ols-solutions-wrapper.component.css'
})
export class WinOlsSolutionsWrapperComponent {

}
